"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Tabs;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Tabs(_ref) {
  var className = _ref.className,
      panes = _ref.panes,
      switchTab = _ref.switchTab,
      activeTab = _ref.activeTab;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui attached tabular menu"
  }, panes.map(function (pane, i) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      as: "a",
      key: i,
      onClick: function onClick() {
        return switchTab(i);
      },
      className: (i === activeTab ? 'active' : '') + " item"
    }, pane.menuItem);
  })), panes.map(function (pane, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "ui bottom attached segment " + (i === activeTab ? 'active' : '') + " tab scroll-box"
    }, pane.pane);
  }));
}